!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports["react-slideshow-image"] = e(require("react")) : t["react-slideshow-image"] = e(t.React);
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 16);
  }([function (t, e, n) {
    t.exports = n(8)();
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = function n() {
        this._tweens = {}, this._tweensAddedDuringUpdate = {};
      };

      n.prototype = {
        getAll: function getAll() {
          return Object.keys(this._tweens).map(function (t) {
            return this._tweens[t];
          }.bind(this));
        },
        removeAll: function removeAll() {
          this._tweens = {};
        },
        add: function add(t) {
          this._tweens[t.getId()] = t, this._tweensAddedDuringUpdate[t.getId()] = t;
        },
        remove: function remove(t) {
          delete this._tweens[t.getId()], delete this._tweensAddedDuringUpdate[t.getId()];
        },
        update: function update(t, e) {
          var n = Object.keys(this._tweens);
          if (0 === n.length) return !1;

          for (t = void 0 !== t ? t : r.now(); n.length > 0;) {
            this._tweensAddedDuringUpdate = {};

            for (var i = 0; i < n.length; i++) {
              var o = this._tweens[n[i]];
              o && !1 === o.update(t) && (o._isPlaying = !1, e || delete this._tweens[n[i]]);
            }

            n = Object.keys(this._tweensAddedDuringUpdate);
          }

          return !0;
        }
      };
      var i,
          r = new n();
      r.Group = n, r._nextId = 0, r.nextId = function () {
        return r._nextId++;
      }, "undefined" == typeof self && void 0 !== t && t.hrtime ? r.now = function () {
        var e = t.hrtime();
        return 1e3 * e[0] + e[1] / 1e6;
      } : "undefined" != typeof self && void 0 !== self.performance && void 0 !== self.performance.now ? r.now = self.performance.now.bind(self.performance) : void 0 !== Date.now ? r.now = Date.now : r.now = function () {
        return new Date().getTime();
      }, r.Tween = function (t, e) {
        this._object = t, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._repeat = 0, this._repeatDelayTime = void 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = null, this._easingFunction = r.Easing.Linear.None, this._interpolationFunction = r.Interpolation.Linear, this._chainedTweens = [], this._onStartCallback = null, this._onStartCallbackFired = !1, this._onUpdateCallback = null, this._onRepeatCallback = null, this._onCompleteCallback = null, this._onStopCallback = null, this._group = e || r, this._id = r.nextId();
      }, r.Tween.prototype = {
        getId: function getId() {
          return this._id;
        },
        isPlaying: function isPlaying() {
          return this._isPlaying;
        },
        to: function to(t, e) {
          return this._valuesEnd = Object.create(t), void 0 !== e && (this._duration = e), this;
        },
        duration: function duration(t) {
          return this._duration = t, this;
        },
        start: function start(t) {
          for (var e in this._group.add(this), this._isPlaying = !0, this._onStartCallbackFired = !1, this._startTime = void 0 !== t ? "string" == typeof t ? r.now() + parseFloat(t) : t : r.now(), this._startTime += this._delayTime, this._valuesEnd) {
            if (this._valuesEnd[e] instanceof Array) {
              if (0 === this._valuesEnd[e].length) continue;
              this._valuesEnd[e] = [this._object[e]].concat(this._valuesEnd[e]);
            }

            void 0 !== this._object[e] && (this._valuesStart[e] = this._object[e], this._valuesStart[e] instanceof Array == !1 && (this._valuesStart[e] *= 1), this._valuesStartRepeat[e] = this._valuesStart[e] || 0);
          }

          return this;
        },
        stop: function stop() {
          return this._isPlaying ? (this._group.remove(this), this._isPlaying = !1, null !== this._onStopCallback && this._onStopCallback(this._object), this.stopChainedTweens(), this) : this;
        },
        end: function end() {
          return this.update(1 / 0), this;
        },
        stopChainedTweens: function stopChainedTweens() {
          for (var t = 0, e = this._chainedTweens.length; t < e; t++) {
            this._chainedTweens[t].stop();
          }
        },
        group: function group(t) {
          return this._group = t, this;
        },
        delay: function delay(t) {
          return this._delayTime = t, this;
        },
        repeat: function repeat(t) {
          return this._repeat = t, this;
        },
        repeatDelay: function repeatDelay(t) {
          return this._repeatDelayTime = t, this;
        },
        yoyo: function yoyo(t) {
          return this._yoyo = t, this;
        },
        easing: function easing(t) {
          return this._easingFunction = t, this;
        },
        interpolation: function interpolation(t) {
          return this._interpolationFunction = t, this;
        },
        chain: function chain() {
          return this._chainedTweens = arguments, this;
        },
        onStart: function onStart(t) {
          return this._onStartCallback = t, this;
        },
        onUpdate: function onUpdate(t) {
          return this._onUpdateCallback = t, this;
        },
        onRepeat: function onRepeat(t) {
          return this._onRepeatCallback = t, this;
        },
        onComplete: function onComplete(t) {
          return this._onCompleteCallback = t, this;
        },
        onStop: function onStop(t) {
          return this._onStopCallback = t, this;
        },
        update: function update(t) {
          var e, n, i;
          if (t < this._startTime) return !0;

          for (e in !1 === this._onStartCallbackFired && (null !== this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), n = (t - this._startTime) / this._duration, n = 0 === this._duration || n > 1 ? 1 : n, i = this._easingFunction(n), this._valuesEnd) {
            if (void 0 !== this._valuesStart[e]) {
              var r = this._valuesStart[e] || 0,
                  o = this._valuesEnd[e];
              o instanceof Array ? this._object[e] = this._interpolationFunction(o, i) : ("string" == typeof o && (o = "+" === o.charAt(0) || "-" === o.charAt(0) ? r + parseFloat(o) : parseFloat(o)), "number" == typeof o && (this._object[e] = r + (o - r) * i));
            }
          }

          if (null !== this._onUpdateCallback && this._onUpdateCallback(this._object, n), 1 === n) {
            if (this._repeat > 0) {
              for (e in isFinite(this._repeat) && this._repeat--, this._valuesStartRepeat) {
                if ("string" == typeof this._valuesEnd[e] && (this._valuesStartRepeat[e] = this._valuesStartRepeat[e] + parseFloat(this._valuesEnd[e])), this._yoyo) {
                  var a = this._valuesStartRepeat[e];
                  this._valuesStartRepeat[e] = this._valuesEnd[e], this._valuesEnd[e] = a;
                }

                this._valuesStart[e] = this._valuesStartRepeat[e];
              }

              return this._yoyo && (this._reversed = !this._reversed), void 0 !== this._repeatDelayTime ? this._startTime = t + this._repeatDelayTime : this._startTime = t + this._delayTime, null !== this._onRepeatCallback && this._onRepeatCallback(this._object), !0;
            }

            null !== this._onCompleteCallback && this._onCompleteCallback(this._object);

            for (var s = 0, u = this._chainedTweens.length; s < u; s++) {
              this._chainedTweens[s].start(this._startTime + this._duration);
            }

            return !1;
          }

          return !0;
        }
      }, r.Easing = {
        Linear: {
          None: function None(t) {
            return t;
          }
        },
        Quadratic: {
          In: function In(t) {
            return t * t;
          },
          Out: function Out(t) {
            return t * (2 - t);
          },
          InOut: function InOut(t) {
            return (t *= 2) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1);
          }
        },
        Cubic: {
          In: function In(t) {
            return t * t * t;
          },
          Out: function Out(t) {
            return --t * t * t + 1;
          },
          InOut: function InOut(t) {
            return (t *= 2) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2);
          }
        },
        Quartic: {
          In: function In(t) {
            return t * t * t * t;
          },
          Out: function Out(t) {
            return 1 - --t * t * t * t;
          },
          InOut: function InOut(t) {
            return (t *= 2) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2);
          }
        },
        Quintic: {
          In: function In(t) {
            return t * t * t * t * t;
          },
          Out: function Out(t) {
            return --t * t * t * t * t + 1;
          },
          InOut: function InOut(t) {
            return (t *= 2) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2);
          }
        },
        Sinusoidal: {
          In: function In(t) {
            return 1 - Math.cos(t * Math.PI / 2);
          },
          Out: function Out(t) {
            return Math.sin(t * Math.PI / 2);
          },
          InOut: function InOut(t) {
            return .5 * (1 - Math.cos(Math.PI * t));
          }
        },
        Exponential: {
          In: function In(t) {
            return 0 === t ? 0 : Math.pow(1024, t - 1);
          },
          Out: function Out(t) {
            return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
          },
          InOut: function InOut(t) {
            return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? .5 * Math.pow(1024, t - 1) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
          }
        },
        Circular: {
          In: function In(t) {
            return 1 - Math.sqrt(1 - t * t);
          },
          Out: function Out(t) {
            return Math.sqrt(1 - --t * t);
          },
          InOut: function InOut(t) {
            return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
          }
        },
        Elastic: {
          In: function In(t) {
            return 0 === t ? 0 : 1 === t ? 1 : -Math.pow(2, 10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI);
          },
          Out: function Out(t) {
            return 0 === t ? 0 : 1 === t ? 1 : Math.pow(2, -10 * t) * Math.sin(5 * (t - .1) * Math.PI) + 1;
          },
          InOut: function InOut(t) {
            return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? -.5 * Math.pow(2, 10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI) : .5 * Math.pow(2, -10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI) + 1;
          }
        },
        Back: {
          In: function In(t) {
            var e = 1.70158;
            return t * t * ((e + 1) * t - e);
          },
          Out: function Out(t) {
            var e = 1.70158;
            return --t * t * ((e + 1) * t + e) + 1;
          },
          InOut: function InOut(t) {
            var e = 2.5949095;
            return (t *= 2) < 1 ? t * t * ((e + 1) * t - e) * .5 : .5 * ((t -= 2) * t * ((e + 1) * t + e) + 2);
          }
        },
        Bounce: {
          In: function In(t) {
            return 1 - r.Easing.Bounce.Out(1 - t);
          },
          Out: function Out(t) {
            return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
          },
          InOut: function InOut(t) {
            return t < .5 ? .5 * r.Easing.Bounce.In(2 * t) : .5 * r.Easing.Bounce.Out(2 * t - 1) + .5;
          }
        }
      }, r.Interpolation = {
        Linear: function Linear(t, e) {
          var n = t.length - 1,
              i = n * e,
              o = Math.floor(i),
              a = r.Interpolation.Utils.Linear;
          return e < 0 ? a(t[0], t[1], i) : e > 1 ? a(t[n], t[n - 1], n - i) : a(t[o], t[o + 1 > n ? n : o + 1], i - o);
        },
        Bezier: function Bezier(t, e) {
          for (var n = 0, i = t.length - 1, o = Math.pow, a = r.Interpolation.Utils.Bernstein, s = 0; s <= i; s++) {
            n += o(1 - e, i - s) * o(e, s) * t[s] * a(i, s);
          }

          return n;
        },
        CatmullRom: function CatmullRom(t, e) {
          var n = t.length - 1,
              i = n * e,
              o = Math.floor(i),
              a = r.Interpolation.Utils.CatmullRom;
          return t[0] === t[n] ? (e < 0 && (o = Math.floor(i = n * (1 + e))), a(t[(o - 1 + n) % n], t[o], t[(o + 1) % n], t[(o + 2) % n], i - o)) : e < 0 ? t[0] - (a(t[0], t[0], t[1], t[1], -i) - t[0]) : e > 1 ? t[n] - (a(t[n], t[n], t[n - 1], t[n - 1], i - n) - t[n]) : a(t[o ? o - 1 : 0], t[o], t[n < o + 1 ? n : o + 1], t[n < o + 2 ? n : o + 2], i - o);
        },
        Utils: {
          Linear: function Linear(t, e, n) {
            return (e - t) * n + t;
          },
          Bernstein: function Bernstein(t, e) {
            var n = r.Interpolation.Utils.Factorial;
            return n(t) / n(e) / n(t - e);
          },
          Factorial: (i = [1], function (t) {
            var e = 1;
            if (i[t]) return i[t];

            for (var n = t; n > 1; n--) {
              e *= n;
            }

            return i[t] = e, e;
          }),
          CatmullRom: function CatmullRom(t, e, n, i, r) {
            var o = .5 * (n - t),
                a = .5 * (i - e),
                s = r * r;
            return (2 * e - 2 * n + o + a) * (r * s) + (-3 * e + 3 * n - 2 * o - a) * s + o * r + e;
          }
        }
      }, e.a = r;
    }).call(this, n(7));
  }, function (t, e, n) {
    "use strict";

    var i,
        r = function r() {
      return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
    },
        o = function () {
      var t = {};
      return function (e) {
        if (void 0 === t[e]) {
          var n = document.querySelector(e);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }(),
        a = [];

    function s(t) {
      for (var e = -1, n = 0; n < a.length; n++) {
        if (a[n].identifier === t) {
          e = n;
          break;
        }
      }

      return e;
    }

    function u(t, e) {
      for (var n = {}, i = [], r = 0; r < t.length; r++) {
        var o = t[r],
            u = e.base ? o[0] + e.base : o[0],
            c = n[u] || 0,
            l = "".concat(u, " ").concat(c);
        n[u] = c + 1;
        var h = s(l),
            p = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        -1 !== h ? (a[h].references++, a[h].updater(p)) : a.push({
          identifier: l,
          updater: y(p, e),
          references: 1
        }), i.push(l);
      }

      return i;
    }

    function c(t) {
      var e = document.createElement("style"),
          i = t.attributes || {};

      if (void 0 === i.nonce) {
        var r = n.nc;
        r && (i.nonce = r);
      }

      if (Object.keys(i).forEach(function (t) {
        e.setAttribute(t, i[t]);
      }), "function" == typeof t.insert) t.insert(e);else {
        var a = o(t.insert || "head");
        if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        a.appendChild(e);
      }
      return e;
    }

    var l,
        h = (l = [], function (t, e) {
      return l[t] = e, l.filter(Boolean).join("\n");
    });

    function p(t, e, n, i) {
      var r = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
      if (t.styleSheet) t.styleSheet.cssText = h(e, r);else {
        var o = document.createTextNode(r),
            a = t.childNodes;
        a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(o, a[e]) : t.appendChild(o);
      }
    }

    function d(t, e, n) {
      var i = n.css,
          r = n.media,
          o = n.sourceMap;
      if (r ? t.setAttribute("media", r) : t.removeAttribute("media"), o && btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), t.styleSheet) t.styleSheet.cssText = i;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }

        t.appendChild(document.createTextNode(i));
      }
    }

    var f = null,
        v = 0;

    function y(t, e) {
      var n, i, r;

      if (e.singleton) {
        var o = v++;
        n = f || (f = c(e)), i = p.bind(null, n, o, !1), r = p.bind(null, n, o, !0);
      } else n = c(e), i = d.bind(null, n, e), r = function r() {
        !function (t) {
          if (null === t.parentNode) return !1;
          t.parentNode.removeChild(t);
        }(n);
      };

      return i(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          i(t = e);
        } else r();
      };
    }

    t.exports = function (t, e) {
      (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = r());
      var n = u(t = t || [], e);
      return function (t) {
        if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
          for (var i = 0; i < n.length; i++) {
            var r = s(n[i]);
            a[r].references--;
          }

          for (var o = u(t, e), c = 0; c < n.length; c++) {
            var l = s(n[c]);
            0 === a[l].references && (a[l].updater(), a.splice(l, 1));
          }

          n = o;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = function (t, e) {
            var n = t[1] || "",
                i = t[3];
            if (!i) return n;

            if (e && "function" == typeof btoa) {
              var r = (a = i, s = btoa(unescape(encodeURIComponent(JSON.stringify(a)))), u = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s), "/*# ".concat(u, " */")),
                  o = i.sources.map(function (t) {
                return "/*# sourceURL=".concat(i.sourceRoot || "").concat(t, " */");
              });
              return [n].concat(o).concat([r]).join("\n");
            }

            var a, s, u;
            return [n].join("\n");
          }(e, t);

          return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
        }).join("");
      }, e.i = function (t, n, i) {
        "string" == typeof t && (t = [[null, t, ""]]);
        var r = {};
        if (i) for (var o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }

        for (var s = 0; s < t.length; s++) {
          var u = [].concat(t[s]);
          i && r[u[0]] || (n && (u[2] ? u[2] = "".concat(n, " and ").concat(u[2]) : u[2] = n), e.push(u));
        }
      }, e;
    };
  }, function (t, e, n) {
    var i = n(3),
        r = n(6);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[t.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    t.exports = r.locals || {};
  }, function (t, e, n) {
    (e = n(4)(!1)).push([t.i, ".react-slideshow-container {\n  display: flex;\n  align-items: center;\n}\n\n.react-slideshow-container .nav {\n  height: 30px;\n  background: rgba(255, 255, 255, 0.6);\n  width: 30px;\n  z-index: 10;\n  text-align: center;\n  cursor: pointer;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-slideshow-container .nav span {\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-color: #000;\n  border-style: solid;\n  transform: rotate(45deg);\n}\n\n.react-slideshow-container .nav.disabled span {\n  border-color: #666;\n}\n\n.react-slideshow-container .nav:hover {\n  background: white;\n  color: #666;\n}\n\n.react-slideshow-container .nav.disabled:hover {\n  cursor: not-allowed;\n}\n\n.react-slideshow-container .nav:first-of-type {\n  margin-right: -30px;\n  border-right: none;\n  border-top: none;\n}\n\n.react-slideshow-container .nav:first-of-type span {\n  margin-left: 5px;\n  border-right: none;\n  border-top: none;\n}\n\n.react-slideshow-container .nav:last-of-type {\n  margin-left: -30px;\n}\n\n.react-slideshow-container .nav:last-of-type span {\n  margin-right: 5px;\n  border-left: none;\n  border-bottom: none;\n}\n\n.react-slideshow-container + div.indicators {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.react-slideshow-container + div.indicators > .each-slideshow-indicator {\n  width: 7px;\n  height: 7px;\n  margin: 0 5px 10px;\n  border-radius: 50%;\n  background: #ccc;\n  cursor: pointer;\n}\n\n.react-slideshow-container + div.indicators > .each-slideshow-indicator:hover {\n  background: #666;\n}\n\n.react-slideshow-container + div.indicators > .each-slideshow-indicator.active {\n  background: #000;\n}\n", ""]), t.exports = e;
  }, function (t, e) {
    var n,
        i,
        r = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }

      try {
        i = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        i = a;
      }
    }();
    var u,
        c = [],
        l = !1,
        h = -1;

    function p() {
      l && u && (l = !1, u.length ? c = u.concat(c) : h = -1, c.length && d());
    }

    function d() {
      if (!l) {
        var t = s(p);
        l = !0;

        for (var e = c.length; e;) {
          for (u = c, c = []; ++h < e;) {
            u && u[h].run();
          }

          h = -1, e = c.length;
        }

        u = null, l = !1, function (t) {
          if (i === clearTimeout) return clearTimeout(t);
          if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(t);

          try {
            i(t);
          } catch (e) {
            try {
              return i.call(null, t);
            } catch (e) {
              return i.call(this, t);
            }
          }
        }(t);
      }
    }

    function f(t, e) {
      this.fun = t, this.array = e;
    }

    function v() {}

    r.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      c.push(new f(t, e)), 1 !== c.length || l || s(d);
    }, f.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = v, r.addListener = v, r.once = v, r.off = v, r.removeListener = v, r.removeAllListeners = v, r.emit = v, r.prependListener = v, r.prependOnceListener = v, r.listeners = function (t) {
      return [];
    }, r.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, r.cwd = function () {
      return "/";
    }, r.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, r.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(9);

    function r() {}

    function o() {}

    o.resetWarningCache = r, t.exports = function () {
      function t(t, e, n, r, o, a) {
        if (a !== i) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: o,
        resetWarningCache: r
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, n) {
    var i = n(3),
        r = n(11);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[t.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    t.exports = r.locals || {};
  }, function (t, e, n) {
    (e = n(4)(!1)).push([t.i, ".react-slideshow-wrapper.slide {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-wrapper .images-wrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]), t.exports = e;
  }, function (t, e, n) {
    var i = n(3),
        r = n(13);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[t.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    t.exports = r.locals || {};
  }, function (t, e, n) {
    (e = n(4)(!1)).push([t.i, ".react-slideshow-fade-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-fade-wrapper .react-slideshow-fade-images-wrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.react-slideshow-fade-wrapper .react-slideshow-fade-images-wrap > div {\n  position: relative;\n  opacity: 0;\n}\n", ""]), t.exports = e;
  }, function (t, e, n) {
    var i = n(3),
        r = n(15);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[t.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    t.exports = r.locals || {};
  }, function (t, e, n) {
    (e = n(4)(!1)).push([t.i, ".react-slideshow-zoom-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-zoom-wrapper .zoom-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n}\n\n.react-slideshow-zoom-wrapper .zoom-wrapper > div {\n  position: relative;\n  display: flex;\n}\n", ""]), t.exports = e;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    n(5);
    var i = n(1),
        r = n.n(i),
        o = n(2),
        a = n(0),
        s = n.n(a);

    function u(t, e) {
      var n = Object.keys(t);
      return Object.keys(e).reduce(function (t, i) {
        return -1 === n.indexOf(i) && (t[i] = e[i]), t;
      }, {});
    }

    n(10);

    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function l(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function h(t) {
      return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function p(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function d(t, e) {
      return (d = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var f = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (n = function (t, e) {
          return !e || "object" !== c(e) && "function" != typeof e ? p(t) : e;
        }(this, h(e).call(this, t))).state = {
          index: t.defaultIndex && t.defaultIndex < t.children.length ? t.defaultIndex : 0
        }, n.width = 0, n.imageContainer = null, n.wrapper = null, n.timeout = null, n.moveSlides = n.moveSlides.bind(p(n)), n.pauseSlides = n.pauseSlides.bind(p(n)), n.startSlides = n.startSlides.bind(p(n)), n.resizeListener = n.resizeListener.bind(p(n)), n.goToSlide = n.goToSlide.bind(p(n)), n.tweenGroup = new o.a.Group(), n;
      }

      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && d(t, e);
      }(e, t), n = e, (i = [{
        key: "componentDidMount",
        value: function value() {
          var t = this;
          this.setWidth(), window.addEventListener("resize", this.resizeListener);
          var e = this.props,
              n = e.autoplay,
              i = e.duration;
          n && (this.timeout = setTimeout(function () {
            return t.goNext();
          }, i));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.willUnmount = !0, clearTimeout(this.timeout), window.removeEventListener("resize", this.resizeListener);
        }
      }, {
        key: "setWidth",
        value: function value() {
          this.allImages = Array.prototype.slice.call(this.wrapper.querySelectorAll(".images-wrap > div"), 0), this.width = this.wrapper.clientWidth;
          var t = this.width * (this.props.children.length + 2);
          this.imageContainer.style.width = "".concat(t, "px"), this.imageContainer.style.transform = "translate(-".concat(this.width * (this.state.index + 1), "px)"), this.applySlideStyle();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(t) {
          var e = this;
          this.props.autoplay !== t.autoplay && (this.props.autoplay ? this.timeout = setTimeout(function () {
            return e.goNext();
          }, this.props.duration) : clearTimeout(this.timeout)), this.props.children.length != t.children.length && this.setWidth();
        }
      }, {
        key: "resizeListener",
        value: function value() {
          this.setWidth();
        }
      }, {
        key: "applySlideStyle",
        value: function value() {
          var t = this;
          this.allImages.forEach(function (e, n) {
            e.style.width = "".concat(t.width, "px");
          });
        }
      }, {
        key: "pauseSlides",
        value: function value() {
          this.props.pauseOnHover && clearTimeout(this.timeout);
        }
      }, {
        key: "startSlides",
        value: function value() {
          var t = this,
              e = this.props,
              n = e.pauseOnHover,
              i = e.autoplay;
          n && i && (this.timeout = setTimeout(function () {
            return t.goNext();
          }, this.props.duration));
        }
      }, {
        key: "moveSlides",
        value: function value(t) {
          "next" === t.currentTarget.dataset.type ? this.goNext() : this.goBack();
        }
      }, {
        key: "goToSlide",
        value: function value(t) {
          var e = t.currentTarget;
          this.goTo(parseInt(e.dataset.key));
        }
      }, {
        key: "goTo",
        value: function value(t) {
          this.slideImages(t);
        }
      }, {
        key: "goNext",
        value: function value() {
          var t = this.state.index,
              e = this.props,
              n = e.children;
          (e.infinite || t !== n.length - 1) && this.slideImages(t + 1);
        }
      }, {
        key: "goBack",
        value: function value() {
          var t = this.state.index;
          (this.props.infinite || 0 !== t) && this.slideImages(t - 1);
        }
      }, {
        key: "showIndicators",
        value: function value() {
          var t = this,
              e = "boolean" != typeof this.props.indicators,
              n = !e && "each-slideshow-indicator";
          return r.a.createElement("div", {
            className: "indicators"
          }, this.props.children.map(function (i, o) {
            return r.a.createElement("div", {
              key: o,
              "data-key": o,
              className: "".concat(n, " ").concat(t.state.index === o && "active"),
              onClick: t.goToSlide
            }, e && t.props.indicators(o));
          }));
        }
      }, {
        key: "showPreviousArrow",
        value: function value() {
          var t = this.props,
              e = t.arrows,
              n = t.prevArrow,
              i = t.infinite,
              o = "";
          return n || (o = "nav ".concat(this.state.index <= 0 && !i && "disabled")), e && r.a.createElement("div", {
            className: o,
            "data-type": "prev",
            onClick: this.moveSlides
          }, n || r.a.createElement("span", null));
        }
      }, {
        key: "showNextArrow",
        value: function value() {
          var t = this.props,
              e = t.arrows,
              n = t.nextArrow,
              i = t.infinite,
              o = t.children,
              a = "";
          return n || (a = "nav ".concat(this.state.index === o.length - 1 && !i && "disabled")), e && r.a.createElement("div", {
            className: a,
            "data-type": "next",
            onClick: this.moveSlides
          }, n || r.a.createElement("span", null));
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
              n = this.props,
              i = n.children,
              o = (n.infinite, n.indicators),
              a = (n.arrows, u(e.propTypes, this.props)),
              s = this.state.index,
              c = {
            transform: "translate(-".concat((s + 1) * this.width, "px)")
          };
          return r.a.createElement("div", a, r.a.createElement("div", {
            className: "react-slideshow-container",
            onMouseEnter: this.pauseSlides,
            onMouseLeave: this.startSlides
          }, this.showPreviousArrow(), r.a.createElement("div", {
            className: "react-slideshow-wrapper slide",
            ref: function ref(e) {
              return t.wrapper = e;
            }
          }, r.a.createElement("div", {
            className: "images-wrap",
            style: c,
            ref: function ref(e) {
              return t.imageContainer = e;
            }
          }, r.a.createElement("div", {
            "data-index": "-1"
          }, i[i.length - 1]), i.map(function (t, e) {
            return r.a.createElement("div", {
              "data-index": e,
              key: e,
              className: e === s ? "active" : ""
            }, t);
          }), r.a.createElement("div", {
            "data-index": "-1"
          }, i[0]))), this.showNextArrow()), o && this.showIndicators());
        }
      }, {
        key: "slideImages",
        value: function value(t) {
          var e = this,
              n = this.props,
              i = n.children,
              r = n.transitionDuration,
              a = n.autoplay,
              s = n.infinite,
              u = n.duration,
              c = n.onChange;

          if (!this.tweenGroup.getAll().length) {
            clearTimeout(this.timeout);
            var l = {
              margin: -this.width * (this.state.index + 1)
            },
                h = new o.a.Tween(l, this.tweenGroup).to({
              margin: -this.width * (t + 1)
            }, r).onUpdate(function (t) {
              e.imageContainer.style.transform = "translate(".concat(t.margin, "px)");
            }).start();
            !function t() {
              e.willUnmount ? e.tweenGroup.removeAll() : (requestAnimationFrame(t), e.tweenGroup.update());
            }(), h.onComplete(function () {
              var n = t < 0 ? i.length - 1 : t >= i.length ? 0 : t;
              e.willUnmount || ("function" == typeof c && c(e.state.index, n), e.setState({
                index: n
              }, function () {
                a && (s || e.state.index < i.length) && (e.timeout = setTimeout(function () {
                  return e.goNext();
                }, u));
              }));
            });
          }
        }
      }]) && l(n.prototype, i), a && l(n, a), e;
    }(i.Component);

    f.defaultProps = {
      duration: 5e3,
      transitionDuration: 1e3,
      defaultIndex: 0,
      infinite: !0,
      autoplay: !0,
      indicators: !1,
      arrows: !0,
      pauseOnHover: !1
    }, f.propTypes = {
      duration: s.a.number,
      transitionDuration: s.a.number,
      defaultIndex: s.a.number,
      infinite: s.a.bool,
      indicators: s.a.oneOfType([s.a.bool, s.a.func]),
      autoplay: s.a.bool,
      arrows: s.a.bool,
      onChange: s.a.func,
      pauseOnHover: s.a.bool,
      prevArrow: s.a.oneOfType([s.a.object, s.a.func]),
      nextArrow: s.a.oneOfType([s.a.object, s.a.func])
    };
    var v = f;
    n(12);

    function y(t) {
      return (y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function m(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function w(t) {
      return (w = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function g(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function b(t, e) {
      return (b = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var _ = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (n = function (t, e) {
          return !e || "object" !== y(e) && "function" != typeof e ? g(t) : e;
        }(this, w(e).call(this, t))).state = {
          index: t.defaultIndex && t.defaultIndex < t.children.length ? t.defaultIndex : 0
        }, n.width = 0, n.timeout = null, n.divsContainer = null, n.wrapper = null, n.setWidth = n.setWidth.bind(g(n)), n.resizeListener = n.resizeListener.bind(g(n)), n.navigate = n.navigate.bind(g(n)), n.preFade = n.preFade.bind(g(n)), n.pauseSlides = n.pauseSlides.bind(g(n)), n.startSlides = n.startSlides.bind(g(n)), n.tweenGroup = new o.a.Group(), n;
      }

      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && b(t, e);
      }(e, t), n = e, (i = [{
        key: "componentDidMount",
        value: function value() {
          window.addEventListener("resize", this.resizeListener), this.setWidth(), this.play();
        }
      }, {
        key: "play",
        value: function value() {
          var t = this,
              e = this.props,
              n = e.autoplay,
              i = e.children,
              r = this.state.index;
          n && i.length > 1 && (clearTimeout(this.timeout), this.timeout = setTimeout(function () {
            return t.fadeImages(r + 1);
          }, this.props.duration));
        }
      }, {
        key: "componentDidUpdate",
        value: function value(t) {
          this.props.autoplay !== t.autoplay && (this.props.autoplay ? this.play() : clearTimeout(this.timeout)), this.props.children.length != t.children.length && (this.applyStyle(), this.play());
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.willUnmount = !0, clearTimeout(this.timeout), window.removeEventListener("resize", this.resizeListener);
        }
      }, {
        key: "setWidth",
        value: function value() {
          this.width = this.wrapper.clientWidth, this.applyStyle();
        }
      }, {
        key: "resizeListener",
        value: function value() {
          this.setWidth();
        }
      }, {
        key: "applyStyle",
        value: function value() {
          var t = this.width * this.props.children.length;
          this.divsContainer.style.width = "".concat(t, "px");

          for (var e = 0; e < this.divsContainer.children.length; e++) {
            var n = this.divsContainer.children[e];
            n && (n.style.width = "".concat(this.width, "px"), n.style.left = "".concat(e * -this.width, "px"));
          }
        }
      }, {
        key: "pauseSlides",
        value: function value() {
          this.props.pauseOnHover && clearTimeout(this.timeout);
        }
      }, {
        key: "startSlides",
        value: function value() {
          var t = this,
              e = this.props,
              n = e.pauseOnHover,
              i = e.autoplay;
          n && i && (this.timeout = setTimeout(function () {
            return t.goNext();
          }, this.props.duration));
        }
      }, {
        key: "goNext",
        value: function value() {
          var t = this.state.index,
              e = this.props,
              n = e.children;
          (e.infinite || t !== n.length - 1) && this.fadeImages((t + 1) % n.length);
        }
      }, {
        key: "goBack",
        value: function value() {
          var t = this.state.index,
              e = this.props,
              n = e.children;
          (e.infinite || 0 !== t) && this.fadeImages(0 === t ? n.length - 1 : t - 1);
        }
      }, {
        key: "navigate",
        value: function value(t) {
          var e = t.currentTarget.dataset;
          e.key != this.state.index && this.goTo(parseInt(e.key));
        }
      }, {
        key: "goTo",
        value: function value(t) {
          this.fadeImages(t);
        }
      }, {
        key: "preFade",
        value: function value(t) {
          "prev" === t.currentTarget.dataset.type ? this.goBack() : this.goNext();
        }
      }, {
        key: "showIndicators",
        value: function value() {
          var t = this,
              e = "boolean" != typeof this.props.indicators,
              n = !e && "each-slideshow-indicator";
          return r.a.createElement("div", {
            className: "indicators"
          }, this.props.children.map(function (i, o) {
            return r.a.createElement("div", {
              key: o,
              "data-key": o,
              className: "".concat(n, " ").concat(t.state.index === o && "active"),
              onClick: t.navigate
            }, e && t.props.indicators(o));
          }));
        }
      }, {
        key: "showPreviousArrow",
        value: function value() {
          var t = this.props,
              e = t.arrows,
              n = t.prevArrow,
              i = t.infinite,
              o = "";
          return n || (o = "nav ".concat(this.state.index <= 0 && !i && "disabled")), e && r.a.createElement("div", {
            className: o,
            "data-type": "prev",
            onClick: this.preFade
          }, n || r.a.createElement("span", null));
        }
      }, {
        key: "showNextArrow",
        value: function value() {
          var t = this.props,
              e = t.arrows,
              n = t.nextArrow,
              i = t.infinite,
              o = t.children,
              a = "";
          return n || (a = "nav ".concat(this.state.index === o.length - 1 && !i && "disabled")), e && r.a.createElement("div", {
            className: a,
            "data-type": "next",
            onClick: this.preFade
          }, n || r.a.createElement("span", null));
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
              n = this.props,
              i = n.indicators,
              o = n.children,
              a = this.state.index,
              s = u(e.propTypes, this.props);
          return r.a.createElement("div", s, r.a.createElement("div", {
            className: "react-slideshow-container",
            onMouseEnter: this.pauseSlides,
            onMouseLeave: this.startSlides
          }, this.showPreviousArrow(), r.a.createElement("div", {
            className: "react-slideshow-fade-wrapper",
            ref: function ref(e) {
              return t.wrapper = e;
            }
          }, r.a.createElement("div", {
            className: "react-slideshow-fade-images-wrap",
            ref: function ref(e) {
              return t.divsContainer = e;
            }
          }, o.map(function (t, e) {
            return r.a.createElement("div", {
              style: {
                opacity: e === a ? "1" : "0",
                zIndex: e === a ? "1" : "0"
              },
              "data-index": e,
              key: e
            }, t);
          }))), this.showNextArrow()), i && this.showIndicators());
        }
      }, {
        key: "fadeImages",
        value: function value(t) {
          var e = this,
              n = this.state.index,
              i = this.props,
              r = i.autoplay,
              a = i.children,
              s = i.infinite,
              u = i.duration,
              c = i.transitionDuration,
              l = i.onChange;
          this.tweenGroup.getAll().length || (this.divsContainer.children[t] || (t = 0), clearTimeout(this.timeout), function t() {
            e.willUnmount ? e.tweenGroup.removeAll() : (requestAnimationFrame(t), e.tweenGroup.update());
          }(), new o.a.Tween({
            opacity: 0
          }, this.tweenGroup).to({
            opacity: 1
          }, c).onUpdate(function (i) {
            e.divsContainer.children[t].style.opacity = i.opacity, e.divsContainer.children[n].style.opacity = 1 - i.opacity;
          }).start().onComplete(function () {
            e.willUnmount || (e.setState({
              index: t
            }), "function" == typeof l && l(n, t), r && (s || t < a.length - 1) && (clearTimeout(e.timeout), e.timeout = setTimeout(function () {
              e.fadeImages((t + 1) % a.length);
            }, u)));
          }));
        }
      }]) && m(n.prototype, i), a && m(n, a), e;
    }(i.Component);

    _.defaultProps = {
      duration: 5e3,
      transitionDuration: 1e3,
      defaultIndex: 0,
      indicators: !1,
      arrows: !0,
      autoplay: !0,
      infinite: !0,
      pauseOnHover: !1
    }, _.propTypes = {
      duration: s.a.number,
      transitionDuration: s.a.number,
      defaultIndex: s.a.number,
      indicators: s.a.oneOfType([s.a.bool, s.a.func]),
      arrows: s.a.bool,
      autoplay: s.a.bool,
      infinite: s.a.bool,
      onChange: s.a.func,
      pauseOnHover: s.a.bool,
      prevArrow: s.a.oneOfType([s.a.object, s.a.func]),
      nextArrow: s.a.oneOfType([s.a.object, s.a.func])
    };
    var x = _;
    n(14);

    function T(t) {
      return (T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function k(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function S(t) {
      return (S = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function O(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function C(t, e) {
      return (C = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var I = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (n = function (t, e) {
          return !e || "object" !== T(e) && "function" != typeof e ? O(t) : e;
        }(this, S(e).call(this, t))).state = {
          index: t.defaultIndex && t.defaultIndex < t.children.length ? t.defaultIndex : 0
        }, n.width = 0, n.timeout = null, n.divsContainer = null, n.wrapper = null, n.setWidth = n.setWidth.bind(O(n)), n.resizeListener = n.resizeListener.bind(O(n)), n.navigate = n.navigate.bind(O(n)), n.preZoom = n.preZoom.bind(O(n)), n.pauseSlides = n.pauseSlides.bind(O(n)), n.startSlides = n.startSlides.bind(O(n)), n.tweenGroup = new o.a.Group(), n;
      }

      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && C(t, e);
      }(e, t), n = e, (i = [{
        key: "componentDidMount",
        value: function value() {
          window.addEventListener("resize", this.resizeListener), this.setWidth(), this.play();
        }
      }, {
        key: "play",
        value: function value() {
          var t = this,
              e = this.props,
              n = e.autoplay,
              i = e.children,
              r = this.state.index;
          n && i.length > 1 && (clearTimeout(this.timeout), this.timeout = setTimeout(function () {
            return t.zoomTo(r + 1);
          }, this.props.duration));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.willUnmount = !0, clearTimeout(this.timeout), window.removeEventListener("resize", this.resizeListener);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(t) {
          this.props.autoplay !== t.autoplay && (this.props.autoplay ? this.play() : clearTimeout(this.timeout)), this.props.children.length != t.children.length && (this.applyStyle(), this.play());
        }
      }, {
        key: "setWidth",
        value: function value() {
          this.width = this.wrapper.clientWidth, this.applyStyle();
        }
      }, {
        key: "resizeListener",
        value: function value() {
          this.setWidth();
        }
      }, {
        key: "applyStyle",
        value: function value() {
          var t = this.width * this.props.children.length;
          this.divsContainer.style.width = "".concat(t, "px");

          for (var e = 0; e < this.divsContainer.children.length; e++) {
            var n = this.divsContainer.children[e];
            n && (n.style.width = "".concat(this.width, "px"), n.style.left = "".concat(e * -this.width, "px"));
          }
        }
      }, {
        key: "pauseSlides",
        value: function value() {
          this.props.pauseOnHover && clearTimeout(this.timeout);
        }
      }, {
        key: "startSlides",
        value: function value() {
          var t = this,
              e = this.props,
              n = e.pauseOnHover,
              i = e.autoplay;
          n && i && (this.timeout = setTimeout(function () {
            return t.goNext();
          }, this.props.duration));
        }
      }, {
        key: "goNext",
        value: function value() {
          var t = this.state.index,
              e = this.props,
              n = e.children;
          (e.infinite || t !== n.length - 1) && this.zoomTo((t + 1) % n.length);
        }
      }, {
        key: "goBack",
        value: function value() {
          var t = this.state.index,
              e = this.props,
              n = e.children;
          (e.infinite || 0 !== t) && this.zoomTo(0 === t ? n.length - 1 : t - 1);
        }
      }, {
        key: "goTo",
        value: function value(t) {
          this.zoomTo(t);
        }
      }, {
        key: "navigate",
        value: function value(t) {
          var e = t.currentTarget.dataset;
          e.key != this.state.index && this.goTo(parseInt(e.key));
        }
      }, {
        key: "preZoom",
        value: function value(t) {
          "prev" === t.currentTarget.dataset.type ? this.goBack() : this.goNext();
        }
      }, {
        key: "showIndicators",
        value: function value() {
          var t = this,
              e = "boolean" != typeof this.props.indicators,
              n = !e && "each-slideshow-indicator";
          return r.a.createElement("div", {
            className: "indicators"
          }, this.props.children.map(function (i, o) {
            return r.a.createElement("div", {
              key: o,
              "data-key": o,
              className: "".concat(n, " ").concat(t.state.index === o && "active"),
              onClick: t.navigate
            }, e && t.props.indicators(o));
          }));
        }
      }, {
        key: "showPreviousArrow",
        value: function value() {
          var t = this.props,
              e = t.arrows,
              n = t.prevArrow,
              i = t.infinite,
              o = "";
          return n || (o = "nav ".concat(this.state.index <= 0 && !i && "disabled")), e && r.a.createElement("div", {
            className: o,
            "data-type": "prev",
            onClick: this.preZoom
          }, n || r.a.createElement("span", null));
        }
      }, {
        key: "showNextArrow",
        value: function value() {
          var t = this.props,
              e = t.arrows,
              n = t.nextArrow,
              i = t.infinite,
              o = t.children,
              a = "";
          return n || (a = "nav ".concat(this.state.index === o.length - 1 && !i && "disabled")), e && r.a.createElement("div", {
            className: a,
            "data-type": "next",
            onClick: this.preZoom
          }, n || r.a.createElement("span", null));
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
              n = this.props,
              i = n.indicators,
              o = (n.arrows, n.infinite, n.children),
              a = this.state.index,
              s = u(e.propTypes, this.props);
          return r.a.createElement("div", s, r.a.createElement("div", {
            className: "react-slideshow-container",
            onMouseEnter: this.pauseSlides,
            onMouseLeave: this.startSlides
          }, this.showPreviousArrow(), r.a.createElement("div", {
            className: "react-slideshow-zoom-wrapper",
            ref: function ref(e) {
              return t.wrapper = e;
            }
          }, r.a.createElement("div", {
            className: "zoom-wrapper",
            ref: function ref(e) {
              return t.divsContainer = e;
            }
          }, o.map(function (t, e) {
            return r.a.createElement("div", {
              style: {
                opacity: e === a ? "1" : "0",
                zIndex: e === a ? "1" : "0"
              },
              "data-index": e,
              key: e
            }, t);
          }))), this.showNextArrow()), i && this.showIndicators());
        }
      }, {
        key: "zoomTo",
        value: function value(t) {
          var e = this,
              n = this.state.index,
              i = this.props,
              r = i.children,
              a = i.scale,
              s = i.autoplay,
              u = i.infinite,
              c = i.transitionDuration,
              l = i.duration,
              h = i.onChange;
          this.tweenGroup.getAll().length || (this.divsContainer.children[t] || (t = 0), clearTimeout(this.timeout), function t() {
            e.willUnmount ? e.tweenGroup.removeAll() : (requestAnimationFrame(t), e.tweenGroup.update());
          }(), new o.a.Tween({
            opacity: 0,
            scale: 1
          }, this.tweenGroup).to({
            opacity: 1,
            scale: a
          }, c).onUpdate(function (i) {
            e.divsContainer.children[t].style.opacity = i.opacity, e.divsContainer.children[n].style.opacity = 1 - i.opacity, e.divsContainer.children[n].style.transform = "scale(".concat(i.scale, ")");
          }).start().onComplete(function () {
            e.willUnmount || ("function" == typeof h && h(n, t), e.setState({
              index: t
            }, function () {
              e.divsContainer.children[n].style.transform = "scale(1)";
            }), s && (u || t < r.length - 1) && (clearTimeout(e.timeout), e.timeout = setTimeout(function () {
              e.zoomTo((t + 1) % r.length);
            }, l)));
          }));
        }
      }]) && k(n.prototype, i), a && k(n, a), e;
    }(i.Component);

    I.defaultProps = {
      duration: 5e3,
      transitionDuration: 1e3,
      defaultIndex: 0,
      indicators: !1,
      arrows: !0,
      autoplay: !0,
      infinite: !0,
      pauseOnHover: !1
    }, I.propTypes = {
      duration: s.a.number,
      transitionDuration: s.a.number,
      defaultIndex: s.a.number,
      indicators: s.a.oneOfType([s.a.bool, s.a.func]),
      scale: s.a.number.isRequired,
      arrows: s.a.bool,
      autoplay: s.a.bool,
      infinite: s.a.bool,
      onChange: s.a.func,
      pauseOnHover: s.a.bool,
      prevArrow: s.a.oneOfType([s.a.object, s.a.func]),
      nextArrow: s.a.oneOfType([s.a.object, s.a.func])
    };
    var E = I;
    n.d(e, "Slide", function () {
      return v;
    }), n.d(e, "Fade", function () {
      return x;
    }), n.d(e, "Zoom", function () {
      return E;
    });
  }]);
});